import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import ResponsiveImage from 'components/util/ResponsiveImage'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import styles from './_syncs.css'
import screen from 'images/app-page/syncs/screen.png'
import stats from 'images/app-page/syncs/stats.png'

function Syncs (props) {
  const { slug } = props.site
  const flavorClass = styles[slug] || ''

  return (
    <div className={styles.syncsWrapper}>
      <div className={`${styles.syncs} ${flavorClass}`}>
        <div className={styles.content}>
          <Title color="white">
            <FormattedMessage id='appPage.syncs.title' defaultMessage='Syncs with Under Armour Smart Shoes' />
          </Title>
          <Caption color="white">
            <FormattedMessage
              id='appPage.syncs.caption'
              defaultMessage='Get the shoes that track everything a runner needs—from pace to your stride length and cadence.'
            />
            <br />
            <a className={styles.callToAction} href="https://www.underarmour.com/en-us/ua-hovr?cid=MMF%7CREF%7CMMFitness%7CSite%7Capp_page%7CHOVR">Learn More</a>
          </Caption>
        </div>
        <div className={styles.stats}>
          <ResponsiveImage large={stats} />
        </div>
        <div className={styles.screen}>
          <img src={screen} />
        </div>
      </div>
    </div>
  )
}

Syncs.propTypes = {
  site: PropTypes.object,
}

export default Syncs



// WEBPACK FOOTER //
// ./src/components/app-page/syncs/index.jsx